import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/insert-management/edit/approval/index.html';

const links: Record<string, string> = {
  insert: '/infoTrac/insert-management',
  submit: '/infoTrac/insert-management?act=approve',
  prevStep: '/infoTrac/insert-management/step3',
  detail: '/infoTrac/insert-management/detail',

  step1: '/infoTrac/insert-management/step1',
  step2: '/infoTrac/insert-management/step2',
  step3: '/infoTrac/insert-management/step3',
  step4: '/infoTrac/insert-management/step4',
};

function InsertManagementEditApproval() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const detail = iframeDocument.getElementById('detail');

      const insert = iframeDocument.getElementsByClassName('insert-management');
      const submit = iframeDocument.getElementsByClassName('saveBtn');
      const prevStep = iframeDocument.getElementsByClassName('prev-step');

      const step1 = iframeDocument.getElementsByClassName('step1');
      const step2 = iframeDocument.getElementsByClassName('step2');
      const step3 = iframeDocument.getElementsByClassName('step3');
      const step4 = iframeDocument.getElementsByClassName('step4');

      if (detail) detail.addEventListener('click', () => window.open(links.detail, '_blank'));

      if (insert.length) {
        for (let i = 0; i < insert.length; i++) {
          insert[i].addEventListener('click', () => navigate(links.insert));
        }
      }

      if (submit.length) {
        for (let i = 0; i < submit.length; i++) {
          submit[i].addEventListener('click', () => navigate(links.submit));
        }
      }

      if (prevStep.length) {
        for (let i = 0; i < prevStep.length; i++) {
          prevStep[i].addEventListener('click', () => navigate(links.prevStep));
        }
      }

      if (step1.length) {
        for (let i = 0; i < step1.length; i++) {
          step1[i].addEventListener('click', () => navigate(links.step1));
        }
      }

      if (step2.length) {
        for (let i = 0; i < step2.length; i++) {
          step2[i].addEventListener('click', () => navigate(links.step2));
        }
      }

      if (step3.length) {
        for (let i = 0; i < step3.length; i++) {
          step3[i].addEventListener('click', () => navigate(links.step3));
        }
      }

      if (step4.length) {
        for (let i = 0; i < step4.length; i++) {
          step4[i].addEventListener('click', () => navigate(links.step4));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="insert-management-edit-approval" src={path} width="100%" height="1000px" />;
}

export default InsertManagementEditApproval;
